import { gql } from '@apollo/client';

const ORGANIZATION_ROLE_FRAGMENT = gql`
  fragment BaseOrganizationRole on OrganizationRole {
    id
    classification
    name
    displayName
    appId
    organizationId
    public
  }
`;

export default ORGANIZATION_ROLE_FRAGMENT;
